import { api } from '@/lib/api';
import type { IApiResponse, IJiraProject, IJiraStatus, IStatusMapping } from '@skystone/shared';

export const jiraApi = {
  getProjects: async () => {
    const res = await api.get<IApiResponse<IJiraProject[]>>('/jira/projects');
    return res.data;
  },

  getProjectStatuses: async (projectKey: string) => {
    const res = await api.get<
      IApiResponse<{ statuses: IJiraStatus[]; mappings: IStatusMapping[] }>
    >(`/jira/projects/${projectKey}/statuses`);
    return res.data;
  },

  saveStatusMappings: async (projectKey: string, mappings: IStatusMapping[]) => {
    const res = await api.post<IApiResponse<{ message: string }>>(
      `/jira/projects/${projectKey}/mappings`,
      mappings
    );
    return res.data;
  },
};
